<template>
  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 edit_account_modal">
    <div class="close_btn" v-on:click="Close()"></div>
    <br />
  </div>
</template>
<script>
import PageLoader from "@/components/shared/PageLoader";
export default {
  components: { PageLoader },
  props: ["Account"],
  data() {
    return {
      isBillingDifferent: true,
      ValidationResult: {},
    };
  },
  methods: {
    Close() {
      document.body.classList.remove("body-overflow");
      this.$emit("exitModal");
    },
  },
  created() {
  },
};
</script>



// WEBPACK FOOTER //
// FrameShippingBilling.vue?57a28625